var URL = global.URL;
module.exports = function (base, type) {
  if (!type) {
    return base;
  }
  var url = new URL(base);
  url.pathname = "".concat(url.pathname, ".").concat(type);
  return url.href;
};